/**
 * Estado de los interruptores de WhatsApp y SMS (apdo. 11.3).
 *
 * Mientras se lee, y si la lectura falla, ambos canales se dan por apagados: es
 * el valor por defecto del backend, que además rechaza el envío por un canal
 * desactivado. Ocultar un botón de más nunca deja un envío sin control.
 */

import { useEffect, useState } from 'react'

import { api } from '../api/cliente'
import type { ConfigCanales } from '../api/tipos'

const APAGADOS: ConfigCanales = { whatsapp: false, sms: false }

export function useCanales(): ConfigCanales {
  const [canales, setCanales] = useState<ConfigCanales>(APAGADOS)
  useEffect(() => {
    let vigente = true
    api
      .canales()
      .then((leidos) => vigente && setCanales(leidos))
      .catch(() => vigente && setCanales(APAGADOS))
    return () => {
      vigente = false
    }
  }, [])
  return canales
}
